// Audit 11-NEW-1 — scheme allow-list for image / video `src`
// attributes rendered from attacker-controlled Craft.js props.
//
// `<img src="javascript:…">` no longer fires in modern browsers,
// but `<a href>`-style sinks slipped through earlier audits, and
// CSS `background-image: url(…)` interpolation (hero.tsx) is a
// known break-out vector when the value isn't scheme-clamped.
// This helper is the single chokepoint so anything reaching an
// `<img>`, `<video>`, or `background-image:` URL is provably
// one of: http / https / data:image/*, or a relative path.
const ALLOWED_PROTOCOLS = new Set(["http:", "https:"]);

export function safeMediaSrc(
  url: string | null | undefined,
): string | undefined {
  if (!url) return undefined;
  const trimmed = url.trim();
  if (!trimmed) return undefined;
  // Allow data:image/* explicitly (e.g. inline thumbnails); reject
  // every other data: payload (text/html, image/svg+xml with script).
  if (/^data:image\/(png|jpe?g|gif|webp|avif);/i.test(trimmed)) {
    return trimmed;
  }
  try {
    const parsed = new URL(trimmed, "https://placeholder.com");
    return ALLOWED_PROTOCOLS.has(parsed.protocol) ? trimmed : undefined;
  } catch {
    return undefined;
  }
}
